export enum InitiatorType {
    System = 'system',
    API = 'api',
    Customer = 'customer',
    BackOfficeUser = 'back-office-user'
  }